import AppState from '@/states/app'

export const WEEK_DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export const SCHEDULE_DAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]

export type WeekDayName = (typeof WEEK_DAYS)[number]
export type ScheduleDayName = (typeof SCHEDULE_DAYS)[number]

export const DEFAULT_APP_START_DAY_OF_WEEK = 0

export const coerceAppStartDayOfWeek = (value: unknown): number => {
  const startDayOfWeek = Number(value)
  return Number.isInteger(startDayOfWeek) &&
    startDayOfWeek >= 0 &&
    startDayOfWeek <= 6
    ? startDayOfWeek
    : DEFAULT_APP_START_DAY_OF_WEEK
}

export const getAppStartDayOfWeek = (): number => {
  const currentLocationDetail = AppState.currentLocationDetail

  if (
    AppState.locationId &&
    currentLocationDetail?.id &&
    currentLocationDetail.id !== AppState.locationId
  ) {
    return DEFAULT_APP_START_DAY_OF_WEEK
  }

  return coerceAppStartDayOfWeek(currentLocationDetail?.appStartDayOfWeek)
}

export const getOrderedWeekDays = (value: unknown): WeekDayName[] => {
  const startDayOfWeek = coerceAppStartDayOfWeek(value)
  return [
    ...WEEK_DAYS.slice(startDayOfWeek),
    ...WEEK_DAYS.slice(0, startDayOfWeek),
  ]
}

export const getOrderedScheduleDays = (value: unknown): ScheduleDayName[] => {
  const startDayOfWeek = coerceAppStartDayOfWeek(value)
  return [
    ...SCHEDULE_DAYS.slice(startDayOfWeek),
    ...SCHEDULE_DAYS.slice(0, startDayOfWeek),
  ]
}

export const getWeekDayIndex = (value: unknown, day: string): number => {
  return getOrderedWeekDays(value).indexOf(day as WeekDayName)
}

export const getScheduleDayIndex = (value: unknown, day: string): number => {
  return getOrderedScheduleDays(value).indexOf(
    day?.toLowerCase() as ScheduleDayName
  )
}
